module.exports = {"id":"dp1_1l3q4","text":"Search, Browse and Filter Information","instructions":"How do you choose the most suitable search tool for a task?","multiselect":false,"category":"1.1","questionType":"PickOne","random":true,"options":[{"id":"dp1_1l3q4-a1","text":"Based on information type","score":3.7},{"id":"dp1_1l3q4-a2","text":"Based on popularity","score":1.3},{"id":"dp1_1l3q4-a3","text":"Based on habit","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.1/l3q4.json
// module id = 930
// module chunks = 41